import { t } from "@/i18n-js/instance";
import { UsageDetailsSection } from "./UsageDetailsSection";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.email_hub";

export const EmailHubUsageDetails = () => (
  <UsageDetailsSection title={t(`${localeRoot}.title`)} showMenu>
    <UsageMetric
      title={t(`${localeRoot}.contacts.title`)}
      progress={50}
      description={t(`${localeRoot}.contacts.description`)}
      price={t(`${localeRoot}.contacts.price`)}
    />
  </UsageDetailsSection>
);
